module.exports = __webpack_public_path__ + "img/wally.8a60b4aa.png";